import React from 'react';

import { FormControl, MenuItem } from '@material-ui/core';

import { ItemSelectorContainer, CustomSelect } from './styles';
import useConfigsStore from '../../../../../../../../../store/configsStore';

export default function ItemQuantitySelector({ quantity, selected, onChange }) {
  //!
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  return (
    <ItemSelectorContainer>
      <FormControl variant="outlined" fullWidth size="small">
        <CustomSelect
          id="quantity-select"
          value={selected}
          onChange={onChange}
          autoWidth
          bordercolor={devolutionPageConfigs?.primaryColor || '#000000'}
        >
          {[...Array(quantity + 1).keys()].map((number, index) => (
            <MenuItem value={number} key={number + index}>
              {number}
            </MenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    </ItemSelectorContainer>
  );
}
